"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

/**
 * Compares to object for shallow equality
 * @param objectA
 * @param objectB
 * @returns {boolean}
 */
var shallowEqual = function shallowEqual(objectA, objectB) {
  if (objectA === objectB) return true;

  if (objectA && objectB && (0, _typeof2["default"])(objectA) === 'object' && (0, _typeof2["default"])(objectB) === 'object') {
    var aKeys = Object.keys(objectA);
    var bKeys = Object.keys(objectB);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every(function (key) {
      return objectA[key] === objectB[key];
    });
  }

  return false;
};

var _default = shallowEqual;
exports["default"] = _default;